import { Navigate } from "react-router-dom";
import DisputeOutlet from "./dispute-outlet";
import { Chargebacks } from "./page/chargebacks";
import { Complaints } from "./page/complaints";

const DisputeRoutes = [
  {
    path: "/disputes",
    element: <DisputeOutlet />,
    children: [
      {
        index: true,
        element: <Navigate to="chargebacks" replace />,
      },
      {
        path: "chargebacks",
        element: <Chargebacks />,
      },
      {
        path: "complaints",
        element: <Complaints />,
      },
    ],
  },
];

export default DisputeRoutes;
